<template>
  <div>
    <CButton
      class="headerActions__button"
      v-c-tooltip="{ content: $t('sender.options.associate.add-user'), placement: 'top' }"
      @click.stop="togglePopUp"
    >
      <CIcon
        name="addUser"
        class="text-gray-600"
        size="custom-size"
        :height="28"
        viewBox="0 0 32 32"
        :class="{ 'text-gray-700': statePopUpAssociate == true }"
      />
    </CButton>

    <transition name="fade" v-if="statePopUpAssociate">
      <div class="dataTable__popUp popUp" @click.stop.stop style="max-width: 250px">
        <div class="popUp__body shadow-sm px-0 pt-4">
          <h5 class="mb-2 px-4">{{ $t('sender.options.associate.text-user') }}</h5>
          <div v-if="loading" class="d-flex flex-column justify-content-center align-items-center p-5 h-100">
            <CSpinner class="my-3" color="primary" />
          </div>
          <ul v-else class="p-0 m-0 list overflow-auto">
            <li
              v-for="(user, index) in users"
              :key="`${user.organizationUserId}-${index}`"
              class="d-flex justify-content-between align-items-center py-2 px-4 list__item"
            >
              {{ users.checked }}
              <span>{{ user.name }}</span>
              <span class="d-flex align-self-center">
                <CSwitch
                  size="sm"
                  class="custom ml-3"
                  :color="setStatus(user.checked)"
                  @update:checked="val => updateListCheck(val, user)"
                  :checked="user.checked"
                />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import services from '@/services.js'
export default {
  name: 'AssociateUser',
  data() {
    return {
      statePopUpAssociate: false,
      color: null,
      loading: false,
      sendersUsers: [],
      usersIdsSender: [],
      organizationUsers: this.$store.state.senders.organizationUsers || [],
    }
  },

  created() {
    this.$root.$on('update-close-popup', () => {
      this.closePopUp()
    })
  },

  beforeDestroy() {
    this.$root.$off('update-close-popup')
  },

  computed: {
    users() {
      return this.organizationUsers.map(user => {
        return {
          ...user,
          checked: this.usersIdsSender.includes(user.organizationUserId),
        }
      })
    },

    typeSender() {
      return this.$store.state.senders.type
    },
  },

  methods: {
    senderUsers(id) {
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services['getUsersSender' + this.typeSender](organizationId, id)
        .then(result => {
          this.sendersUsers = result.data.data
          this.usersIdsSender = this.listUserIdsInSender(result.data.data)
        })
        .catch(({ response }) => {
          this.$emit('response-message', {
            status: 'danger',
            text: response.data.message || 'Erro',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    listUserIdsInSender(arr) {
      return arr.map(item => item.organizationUserId) || []
    },

    setStatus(checked) {
      return checked ? 'success' : 'danger'
    },

    togglePopUp() {
      this.statePopUpAssociate = !this.statePopUpAssociate
      this.statePopUpAssociate && this.$store.state.senders.id && this.senderUsers(this.$store.state.senders.id)
    },

    getuserSendId(id) {
      //se senderDomain
      if (this.sendersUsers[0].userDomainSenderId) {
        return this.sendersUsers.find(user => user.organizationUserId == id).userDomainSenderId
      }
      //se senderSMS
      return this.sendersUsers.find(user => user.organizationUserId == id).id
    },

    updateListCheck(checked, user) {
      if (!checked) {
        const ID = this.getuserSendId(user.organizationUserId)
        this.removeUserSender(this.$store.state.senders.id, ID)
        return
      }

      this.addUserSender(this.$store.state.senders.id, {
        organizationUserId: user.organizationUserId,
      })
    },

    addUserSender(organizationSenderId, organizationUserId) {
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services['addUserSender' + this.typeSender](organizationId, organizationSenderId, organizationUserId)
        .then(() => {
          this.senderUsers(this.$store.state.senders.id)
          this.$emit('response-message', {
            status: 'success',
            text: this.$t('sender.options.associate.success') || 'Success',
          })
        })
        .catch(({ response }) => {
          this.$emit('response-message', {
            status: 'danger',
            text: response.data.message || 'Erro',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    removeUserSender(organizationSenderId, organizationUserId) {
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services['removeUserSender' + this.typeSender](organizationId, organizationSenderId, organizationUserId)
        .then(() => {
          this.senderUsers(this.$store.state.senders.id)
          this.$emit('response-message', {
            status: 'success',
            text: this.$t('sender.options.associate.disfellowshipped') || 'Success',
          })
        })
        .catch(({ response }) => {
          this.$emit('response-message', {
            status: 'danger',
            text: response.data.message || 'Erro',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    closePopUp() {
      this.statePopUpAssociate = false
    },
  },
}
</script>

<style lang="scss" scope>
.list {
  max-height: 300px;
  overflow-x: scroll;
  &__item {
    color: var(--gray-700);

    &:hover {
      background: transparentize($primary, 0.75);
    }
  }

  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: var(--gray-500);
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #f1f1f1;
  }
}
</style>
